// @ts-nocheck

import { __ } from '../i18n/l10n';
import { MarketIds } from '../types/market';

export const MyMatchLocaleErrorIds = Object.freeze({
  MATCH_WAS_ALREADY_HERE_BEFORE_COMPLETION: 1,
});

export const MyMatchAPIErrorIds = Object.freeze({
  SELECTION_SUSPENDED: -1,
  CONTRADICTING_SELECTIONS: -2,
  TOO_MANY_MULTICHOICES_SELECTED: -3,
  SELECTION_INACTIVE: -4,
  UNHANDLED_SELECTION: -5,
  MY_MATCH_UNAVAILABLE: -6,
  UNEXPECTED_ERROR: -7,
});

export const MyMatchAPIGlobalsErrorIds = [
  MyMatchAPIErrorIds.CONTRADICTING_SELECTIONS,
  MyMatchAPIErrorIds.MY_MATCH_UNAVAILABLE,
  MyMatchAPIErrorIds.UNEXPECTED_ERROR,
];

export const MyMatchAPISpecificsErrorIds = Object.keys(MyMatchAPIErrorIds).map(
  (key) => !~MyMatchAPIGlobalsErrorIds.indexOf(key),
);

export const MyMatchLongErrorLabels = new Proxy(
  {
    [MyMatchAPIErrorIds.CONTRADICTING_SELECTIONS]: () => __('Contradictory selections. Check your betslip.'),
    [MyMatchAPIErrorIds.UNHANDLED_SELECTION]: () =>
      __('At least one of your selections is not eligible for MyMatch. Check your betslip.'),
    [MyMatchAPIErrorIds.SELECTION_INACTIVE]: () =>
      __('At least one of your selections is no longer available. Check your betslip.'),
    [MyMatchAPIErrorIds.SELECTION_SUSPENDED]: () => __('At least one of your selections is currently suspended'),
    // eslint-disable-next-line sonarjs/no-duplicate-string
    [MyMatchAPIErrorIds.MY_MATCH_UNAVAILABLE]: () => __('MyMatch currently unavailable'),
    [MyMatchAPIErrorIds.UNEXPECTED_ERROR]: () => __('MyMatch currently unavailable'),
    [MyMatchAPIErrorIds.TOO_MANY_MULTICHOICES_SELECTED]: () =>
      __('At least one of your multi-chance selections has too many choices.'),
    [MyMatchLocaleErrorIds.MATCH_WAS_ALREADY_HERE_BEFORE_COMPLETION]: () =>
      __('This match is already included in the betslip you wish to enhance.'),
  },
  {
    get(origin, key) {
      if (!origin[key]) {
        return () => __('MyMatch currently unavailable');
      }
      return origin[key];
    },
  },
);

export const MyMatchShortErrorLabels = new Proxy(
  {
    [MyMatchAPIErrorIds.CONTRADICTING_SELECTIONS]: () => __('Contradictory selections.'),
    [MyMatchAPIErrorIds.MY_MATCH_UNAVAILABLE]: () => __('MyMatch currently unavailable'),
    [MyMatchAPIErrorIds.TOO_MANY_MULTICHOICES_SELECTED]: () =>
      __('At least one of your multi-chance selections has too many choices.'),
    [MyMatchAPIErrorIds.SELECTION_INACTIVE]: () => __('At least one of your selections is no longer available.'),
    [MyMatchAPIErrorIds.SELECTION_SUSPENDED]: () => __('At least one of your selections is currently suspended'),
    [MyMatchAPIErrorIds.UNEXPECTED_ERROR]: () => __('MyMatch currently unavailable'),
    [MyMatchAPIErrorIds.UNHANDLED_SELECTION]: () => __('At least one of your selections is not eligible for MyMatch.'),
    [MyMatchLocaleErrorIds.MATCH_WAS_ALREADY_HERE_BEFORE_COMPLETION]: () =>
      __('This match is already included in the betslip you wish to enhance.'),
  },
  {
    get(origin, key) {
      if (!origin[key]) {
        return () => __('MyMatch currently unavailable');
      }
      return origin[key];
    },
  },
);

export const NoBasketSplitByDefaultMyMatchErrorIds = [
  MyMatchAPIErrorIds.SELECTION_INACTIVE,
  MyMatchAPIErrorIds.SELECTION_SUSPENDED,
  MyMatchAPIErrorIds.TOO_MANY_MULTICHOICES_SELECTED,
  MyMatchAPIErrorIds.CONTRADICTING_SELECTIONS,
];

export const MyMatchHelperTooltipLabelsByMarketId = {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  [MarketIds.MARKET_ID_DOUBLE_CHANCE_GOALSCORER]: () => __('Want another multi-chance accumulator? Switch to MyMatch!'),
  [MarketIds.MARKET_ID_TRIPLE_CHANCE_GOALSCORER]: () => __('Want another multi-chance accumulator? Switch to MyMatch!'),
  [MarketIds.MARKET_ID_CORRECT_SCORE_MULTICHOICE]: () =>
    __('Want another multi-chance accumulator? Switch to MyMatch!'),
  [MarketIds.MARKET_ID_BOTH_PLAYERS_TO_SCORE]: () => __('Want another accumulator? Switch to MyMatch!'),
};
